import React from 'react';
import { CommonPrelanderV20 } from '../../components/CommonPrelanderV20';
import { QUIZ_SLIDES_V14 } from '../../shared/quiz-slides/quiz-slides-v14';

function PrelanderV28Page({ initialPrelander }) {
    return (
        <CommonPrelanderV20
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V14}
        />
    );
}

export {
    PrelanderV28Page
};
